import { Phone, MessageSquare, X } from 'lucide-react';
import { useState } from 'react';

export function CrisisChip({ onOpen }) {
  return (
    <button
      onClick={onOpen}
      data-testid="crisis-chip"
      className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-red-200 text-red-700 text-sm font-medium shadow-sm hover:bg-red-50 transition-smooth"
    >
      <Phone size={14} /> Crisis? Get help now
    </button>
  );
}

export function CrisisModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div
        onClick={(e) => e.stopPropagation()}
        data-testid="crisis-modal"
        className="w-full max-w-md bg-white rounded-3xl p-8 card-soft animate-fade-up"
      >
        <div className="flex items-start justify-between mb-4">
          <div>
            <h3 className="font-heading text-2xl">You are not alone</h3>
            <p className="text-sm text-navy/60 mt-1">Free, confidential, 24/7.</p>
          </div>
          <button onClick={onClose} data-testid="crisis-close" className="text-navy/60"><X size={20} /></button>
        </div>
        <div className="space-y-3">
          <a href="tel:988" data-testid="crisis-call-988" className="flex items-center gap-3 p-4 rounded-2xl bg-navy text-white">
            <Phone size={20} /> <div><div className="font-medium">Call or text 988</div><div className="text-xs opacity-80">Suicide & Crisis Lifeline</div></div>
          </a>
          <a href="sms:741741&body=HOME" data-testid="crisis-text-741" className="flex items-center gap-3 p-4 rounded-2xl bg-beige text-navy">
            <MessageSquare size={20} /> <div><div className="font-medium">Text HOME to 741741</div><div className="text-xs opacity-70">Crisis Text Line</div></div>
          </a>
          <a href="tel:911" data-testid="crisis-call-911" className="flex items-center gap-3 p-4 rounded-2xl border border-red-200 text-red-700">
            <Phone size={20} /> <div><div className="font-medium">Call 911</div><div className="text-xs opacity-70">If you are in immediate danger</div></div>
          </a>
        </div>
        <p className="text-xs text-navy/50 mt-6">Brotherhood+ is not therapy and not a substitute for professional mental health care.</p>
      </div>
    </div>
  );
}

export function useCrisis() {
  const [open, setOpen] = useState(false);
  return { open, setOpen };
}
